import { Component } from 'react';
import { Box, Grid } from '@mui/material';

import Bio from '../bio/Bio';
import Info from '../bio/Info';

export default class About extends Component {
  componentDidMount() {
    document.title = 'LeKinaSá | About Me';
  }

  render() {
    return (
      <Grid container className='fill-screen' sx={{ width: '100%' }} >
        <Grid className='center-flex grid-item' key='1' size={{ xs: 12, lg: 8 }} >
          <Box className='bio'>
            <Box className='center-block'>
              <Bio />
            </Box>
          </Box>
        </Grid>
        <Grid className='info grid-item' key='2' size={{ xs: 12, lg: 4 }} >
          <Info />
        </Grid>
      </Grid>
    );
  }
}
